import { colors } from './colors'

export const boxes = {
  box1: {
    id: 'box1',
    color: colors.general.red,
    textOnColor: 'white',
    response: 'Had no idea',
  },
  box2: {
    id: 'box2',
    color: colors.general.yellow,
    textOnColor: 'white',
    response: 'Rings a bell',
  },
  box3: {
    id: 'box3',
    color: colors.general.orange,
    textOnColor: 'white',
    response: 'Almost had it',
  },
  box4: {
    id: 'box4',
    color: colors.general.blue,
    textOnColor: 'white',
    response: 'Got it',
  },
  box5: {
    id: 'box5',
    color: colors.general.green,
    textOnColor: 'white',
    response: 'Smashed it',
  },
}

export const boxList = [boxes.box1, boxes.box2, boxes.box3, boxes.box4, boxes.box5]



// WEBPACK FOOTER //
// ./src/module/boxes.js